import { t } from '@unistocks/shared/localization/index.ts';
import { isNumber } from '@unistocks/shared/utils/util';
import { Option } from '@unistocks/types';

/**
 * @param _enum
 * @param enumName Name of the enum to be used in the key.
 * The key can then be used directly in the translate function.
 * If not provided, the key will be the enum member name.
 */
export function mapEnumToOptions<T>(
  _enum: T,
  enumName?: string
): ReadonlyArray<Option<T[Extract<keyof T, string>]>> {
  const options: Option<T[Extract<keyof T, string>]>[] = [];

  for (const member in _enum) {
    if (!isNumber(Number(member)))
      options.push({
        key: enumName ? `::Enum:${enumName}:${_enum[member]}` : member,
        value: _enum[member]
      });
  }

  return options;
}

/**
 * Translate enum options.
 * @param options
 * @returns
 */
export const translateEnumOptions = <T = any>(options: Readonly<Option<T>[]>) =>
  options.map(({ key, value }) => ({
    key: t(key),
    value
  }));
